import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { Feedback, UpdateFeedbackPayload } from "@/models/feedback";
import { IFeedbackApi } from "./IFeedbackApi";

@injectable()
export class FeedbackApi implements IFeedbackApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/feedback";

  async getAll(): Promise<Feedback[]> {
    const { data } = await this.client.get<Feedback[]>(this.baseUrl);
    return data;
  }

  async update(id: string, payload: UpdateFeedbackPayload): Promise<Feedback> {
    const { data } = await this.client.patch<Feedback>(`${this.baseUrl}/${id}`, payload);
    return data;
  }

  async remove(id: string): Promise<void> {
    await this.client.delete(`${this.baseUrl}/${id}`);
  }
}
